import React from "react";

import screen1 from "../../img/screen-1.png";
import screen2 from "../../img/screen-2.png";
import screen3 from "../../img/screen-3.png";
import screen4 from "../../img/screen-4.png";

const listado_screens = [
    {
        title_blue: "CRM Inteligente",
        title_black: "para una gestión eficiente",
        description:
            "Automatiza la administración de clientes y pagos con un sistema eficiente. Organiza tu base de datos, centraliza la comunicación y agiliza el seguimiento de reservas. Optimiza cada interacción y mejora la experiencia de tus clientes. Ahorra tiempo y maximiza tu productividad con procesos automatizados.",
        screen: screen1,
    },

    {
        title_blue: "Web Personalizada",
        title_black: "para potenciar tu marca",
        description:
            "Diseñamos una página web única con secciones exclusivas para alquiler y venta. Aumenta tu visibilidad, mejora la conversión y ofrece una experiencia profesional a tus clientes. Tu marca, tu estilo, tu éxito. Destaca frente a la competencia con un diseño moderno y atractivo.",
        screen: screen2,
    },

    {
        title_blue: "Calendarios Dinámicos",
        title_black: "con tarifas flexibles",
        description:
            "Adapta los precios según la temporada y mantén tu disponibilidad siempre actualizada. Automatiza las reservas, evita conflictos de fechas y maximiza la ocupación de tu propiedad sin esfuerzo. Gestiona todo desde una sola plataforma con total control.",
        screen: screen3,
    },

    {
        title_blue: "Módulos Promocionales",
        title_black: "para aumentar reservas",
        description:
            "Crea descuentos y ofertas personalizadas para atraer más clientes. Potencia la ocupación en temporadas bajas y fideliza a tus huéspedes con promociones irresistibles. ¡Convierte visitantes en reservas seguras! Genera demanda con estrategias efectivas y dinámicas.",
        screen: screen4,
    },
];

const ElegirBlustay = () => {
    return (
        <div className="w-full 2xl:mt-20 xl:mt-10 lg:mt-5">
            <div className="3xl:w-2/3 2xl:w-3/4 lg:w-4/5 w-5/6 mx-auto ">
                <div className="text-[#071829] 2xl:text-4xl xl:text-3xl text-2xl font-bold text-center md:text-left   ">
                    ¿Por que elegir BluStay?
                </div>
                <div className="text-[#071829] 2xl:text-xl xl:text-base lg:text-base md:text-sm text-xs  mt-5  md:w-2/3 w-full text-center md:text-left  ">
                    BluStay es la mejor opción para propietarios que buscan
                    optimizar la gestión de sus alojamientos sin preocupaciones.
                    Nuestra exclusiva plataforma te ofrece:
                </div>

                {listado_screens.map((screen, index) => (
                    <div
                        key={index}
                        className={`flex ${
                            (index + 1) % 2 === 0
                                ? "md:flex-row-reverse flex-col"
                                : "md:flex-row flex-col"
                        } justify-between items-center w-full md:gap-x-20 mt-10 `}
                    >
                        <div className="md:w-2/5">
                            <img src={screen.screen} alt="screen" />
                        </div>

                        <div className="md:w-3/5 ">
                            <div className="flex gap-1 2xl:text-4xl xl:text-3xl text-2xl font-semibold flex-wrap text-center">
                                <span className="text-[#029DE0] font-bold">
                                    {screen.title_blue}
                                </span>
                                <span className="text-[#071829]">
                                    {screen.title_black}
                                </span>
                            </div>
                            <div className="xl:text-base md:text-sm text-xs mt-5 text-justify md:text-left ">
                                {screen.description}
                            </div>
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default ElegirBlustay;
